export default {
  idle: 'idle',
  pending: 'pending',
  success: 'success',
  failure: 'failure',
};
